import { baseURL } from "../../../api"
import { Monster } from "../../../types/LogicTypes"

type Props = {
    monster: Monster
    size?: number
}
const MonsterThumbnail: React.FC<Props> = (props) => {
    return (
        <>
            <div className="char-thumbnail"
                style={{
                    backgroundImage: `url(${baseURL}/${props.monster.texture.img})`,
                    width: `${props.size ?? 80}px`,
                    height: `${props.size ?? 80}px`,
                    borderRadius: `${(props.size ?? 80) / 2}px`,
                }}>
                <div className="subicon left" style={{ backgroundColor: "#400000" }}>
                    <span style={{color: "rgba(255, 0, 0, 0.5)"}}>
                        {props.monster.health ?? 0}
                    </span>
                </div>
            </div>
        </>
    )
}
export default MonsterThumbnail